// extracted by mini-css-extract-plugin
export default {"ourTeam":"our-team_ourTeam__GOrzK","teamWrap":"our-team_teamWrap__Q+f4S"};